// Libraries
import {
  Component,
  OnInit
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators
}  from '@angular/forms';

// Forms
import { FormUtils } from './../../woopa-ui/forms';

// Services
import { Angular2TokenService } from 'angular2-token';

/**
 * `ForgotComponent` Request reset password to email.
 */
@Component({
  template: require('./forgot.component.html')
})
export class ForgotComponent implements OnInit {
  /**
   * From group for forgot password.
   */
  public forgotForm: FormGroup;
  /**
   * Flag to maintain if request is running or not.
   */
  public isLoading = false;
  /**
   * Keep current form errors.
   */
  public formErrors = {
    'email': '',
  };
  /**
   * Store validation error messages.
   */
  public validationMessages = {
    'email': {
      'email': 'Formato de correo electrónico incorrecto.'
    },
  };
  /**
   * Forgot errors.
   */
  public errors = [];
  /**
   * Success message
   */
  public successMessage = null;

  /**
   * Creates a new `ForgotComponent` instance.
   */
  constructor(
    private tokenService: Angular2TokenService,
    private fb: FormBuilder
    ) {
    }

  /**
   * Implements on init mehotd
   */
  public ngOnInit() {
    // Buid form
    this.buildForm();
  }

  /**
   * Request reset password
   */
  public requestPassword(): any {
    // Do forgot and redirect
    const formModel = this.forgotForm.value;
    const params = {
      email: formModel.email
    };
    // Toggle loading flag
    this.isLoading = true;
    // Make forgot
    this.tokenService.resetPassword(params).subscribe(
      (res) => {
        // Toggle loading flag
        this.isLoading = false;
        // Get success message
        this.successMessage = res.json().message;
      },
      (res) => {
        const response = res.json();
        // Toggle loading flag
        this.isLoading = false;
        // Save login errors
        if (response.errors) {
          this.errors = response.errors;
        }
      }
    );
  }

  /**
   * Create request reset password form group and controls
   */
  private buildForm(): void {
    this.forgotForm = this.fb.group({
      'email': ['', Validators.email]
    });
    this.forgotForm.valueChanges
      .subscribe(data => this.onValueChanged(data));
    // (re)set validation messages now
    this.onValueChanged();
  }

  /**
   * Handles object value changes.
   * @param _data Data
   */
  private onValueChanged(_data?: any) {
    if (!this.forgotForm) {
      return;
    }
    // Clear errors
    this.errors = [];
    // Parse form errors
    this.formErrors = FormUtils.parseErrors(this.forgotForm, this.formErrors, this.validationMessages);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/public/forgot/forgot.component.ts